import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as resultCodes from "../../constants/resultCodes";
import * as messageHelper from "../../helpers/messageHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.ADD_USER:
        case handlers.RESTORE_USER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_USERS,
                        params: {
                            activeOnly: false
                        }
                    },
                    method: handlers.GET_ALL_USERS,
                    tabId: 0
                },
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.EDIT_USER_MODAL
                    }
                }
            ];
        case handlers.UPDATE_USER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let userActions = [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_USERS,
                        params: {
                            activeOnly: false
                        }
                    },
                    method: handlers.GET_ALL_USERS,
                    tabId: 0
                },
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.EDIT_USER_MODAL
                    }
                }
            ];

            if (state.global.activeUser !== null) {
                userActions.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_SELECTED_USER_GROUPS,
                        params: {
                            userId: state.global.activeUser.userId,
                            isLocal: state.global.activeUser.isLocal
                        }
                    },
                    method: handlers.GET_SELECTED_USER_GROUPS,
                    tabId: 0
                });
            }

            return userActions;
        case handlers.DELETE_USER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ALL_USERS,
                        params: {
                            activeOnly: false
                        }
                    },
                    method: handlers.GET_ALL_USERS,
                    tabId: 0
                }
            ];
        case handlers.CHANGE_USER_PASSWORD:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.EDIT_PASSWORD_MODAL
                    }
                }
            ];
        case handlers.GET_SELECTED_USER_GROUPS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_SELECTED_USER_GROUPS,
                    payload: {
                        userGroupsList: response.data
                    }
                }
            ];
        case handlers.ADD_USER_INTO_GROUP:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_SELECTED_USER_GROUPS,
                        params: {
                            userId: state.global.activeUser.userId,
                            isLocal: state.global.activeUser.isLocal
                        }
                    },
                    method: handlers.GET_SELECTED_USER_GROUPS,
                    tabId: 0
                }
            ];
        case handlers.REMOVE_USER_FROM_GROUP:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_SELECTED_USER_GROUPS,
                        params: {
                            userId: state.global.activeUser.userId,
                            isLocal: state.global.activeUser.isLocal
                        }
                    },
                    method: handlers.GET_SELECTED_USER_GROUPS,
                    tabId: 0
                }
            ];
        case handlers.REMOVE_USER_FROM_ALL_GROUPS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_SELECTED_USER_GROUPS,
                        params: {
                            userId: state.global.activeUser.userId,
                            isLocal: state.global.activeUser.isLocal
                        }
                    },
                    method: handlers.GET_SELECTED_USER_GROUPS,
                    tabId: 0
                }
            ];
        case handlers.GET_ALL_USERS:
            if (!responseHelper.isGetAllUsersFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_USER_LIST,
                    payload: {
                        userList: response.data
                    }
                }
            ];
        case handlers.GET_ALL_USER_GROUPS:
            if (!responseHelper.isGetAllUsersFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_USER_GROUPS_LIST,
                    payload: {
                        userGroupsList: response.data
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
